import { IGetAllClienteCentroCustoUseCase } from "../../../presentation/useCases/read/get_all_cliente_centro_custo_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";
import { ClienteCentroCustoLista } from "../../models/clienteCentroCustoLista";

/**
 * GetAllClienteCentroCustoUseCase
 */

export class GetAllClienteCentroCustoUseCase extends BasePaginatedUseCase<ClienteCentroCustoLista>
  implements IGetAllClienteCentroCustoUseCase {
  constructor(private readonly repository: IComercialRepository) {
    super();
  }

  async execute(
    idCliente: number,
    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const response = await this.repository.getAllClienteCentroCustoLista(
      idCliente,
      currentPage,
      rowsPerPage
    );

    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }

}

